<mat-card
    appearance="outlined"
    class="job-flow-stack-card hdmui-background-2"
    [class.job-flow-stack-card--input-completed]="isInputStackCompleted()"
>
    <div class="job-flow-stack-card__content">
        <div class="job-flow-stack-card__row">
            <mat-icon svgIcon="hdmui:palletHigh" class="job-flow-stack-card__icon"></mat-icon>
            <span class="job-flow-stack-card__title hdmui-font-bold">
                #{{ stack().sequenceNumber }}:
                <span class="hdmui-font-bold hdmui-success">{{ stack().stackQuantityGood }}</span>
                /
                <span class="hdmui-font-bold hdmui-warning-strong">{{ stack().stackQuantityWaste }}</span>
            </span>
        </div>
        <span class="job-flow-stack-card__id hdmui-caption" [title]="stack().stackId">{{ stack().stackId }}</span>
        @if (stack().location) {
            <span class="job-flow-stack-card__location hdmui-caption">
                {{ '*.label.location' | translate }}: {{ stack().location }}
            </span>
        }
    </div>
</mat-card>
